module.exports = __webpack_public_path__ + "static/media/8.7c3c88f0.jpg";